import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { forkJoin, Observable, of } from "rxjs";
import { catchError, map, tap } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class CandPreviewService {

  constructor(private http: HttpClient) { }
  // Get preview Data page 
  getPreviewCandData(appStatusId: number, maritalId: number, militaryStatusId: number, liveWithId: number, countryId: number, regionId: number, provinceId: number, cityId: number) {
    return forkJoin([
      // this.http.get(`${environment.API_URL_ADM}/api/admcandidate/${candId}`),
      this.http.get(`${environment.API_URL_ADM}/api/admappstatus/${appStatusId ?? 0}`).pipe(map(res => res), catchError(e => of('Oops!'))),
      this.http.get(`${environment.API_URL_ADM}/api/admmaritalstatus/${maritalId ?? 0}`).pipe(map(res => res), catchError(e => of('Oops!'))),
      this.http.get(`${environment.API_URL_ADM}/api/admmilstatus/${militaryStatusId ?? 0}`).pipe(map(res => res), catchError(e => of('Oops!'))),
      this.http.get(`${environment.API_URL_ADM}/api/admlivewith/${liveWithId ?? 0}`).pipe(map(res => res), catchError(e => of('Oops!'))),
      this.http.get(`${environment.API_URL}/api/syscountries/${countryId ?? 0}`).pipe(map(res => res), catchError(e => of('Oops!'))),
      this.http.get(`${environment.API_URL}/api/sysregions/${regionId ?? 0}`).pipe(map(res => res), catchError(e => of('Oops!'))),
      this.http.get(`${environment.API_URL}/api/sysprovinces/${provinceId ?? 0}`).pipe(map(res => res), catchError(e => of('Oops!'))),
      this.http.get(`${environment.API_URL}/api/syscities/${cityId ?? 0}`).pipe(map(res => res), catchError(e => of('Oops!'))),
    ]);
  }

  updateCandEmail(orgId: number, cid: number, eml: string, usr: string) {
    return this.http.get<any>(
      `${environment.API_URL}/api/updatecandidateemail/${orgId}/${cid}/${eml}/${usr}`);
  }
  
  updateCandNationalId(orgId: number, cid: number, nid: string, usr: string) {
    return this.http.get<any>(
      `${environment.API_URL}/api/updatecandidatenid/${orgId}/${cid}/${nid}/${usr}`);
  }

    
  sendingVerficationMail( cid: number) {
    return this.http.get<any>(
      `${environment.API_URL}/api/sysresendemaillogbycandidate/${cid}`);
  }

      
  onCandArchieving( orgId:number,cid: number,user:string,rmk:string) {
    return this.http.get<any>(
      `${environment.API_URL}/api/archivecandidate/${orgId}/${cid}/${user}/${rmk}`);
  }
}
